import { render, staticRenderFns } from "./editMemberDiary.vue?vue&type=template&id=2124e71a&"
import script from "./editMemberDiary.vue?vue&type=script&lang=js&"
export * from "./editMemberDiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports